/**
 * Check if a color is a valid hex color with or without alpha
 * @param {string} color - The color to check
 * @returns {boolean} - True if the color is a valid hex color with or without alpha, false otherwise
 */
export default function isHexColor(color) {
  return /^#[0-9A-F]{6}([0-9A-F]{2})?$/i.test(color);
}
